import React, { useState, useEffect, useCallback } from 'react'
import { toast } from 'react-toastify'
import * as Yup from "yup"
import { useFormik, FieldArray, FormikProvider } from "formik"
import { request } from '../../services/request'
import { Form } from "react-bootstrap"
import PrimaryButton from '../subComponents/PrimaryButton'
import SecondaryButton from '../subComponents/SecondaryButton'
import { SendNotifications } from '../../services/authinterface'
import { useNavigate, useParams } from "react-router-dom"
import { useDispatch } from 'react-redux'
import { changeloaderState } from '../../store/loaderSlice'

const SensorSosSettingsComp = () => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const param = useParams()

    const fetchSensorSosSettingsDetails = useCallback(async () => {
        try {
            dispatch(changeloaderState(true))
            const response = await request<any>({
                url: `/wdqwd/${param.id}`,
                method: "GET",
            })
            if (response.success) {
                // if response contains values, set them here with formik.setValues
                formik.setValues({
                    sensorId: response.data?.sensorId || "",
                    sosIds: response.data?.sosIds?.length ? response.data.sosIds : [""],
                })
            } else {
                toast.error("Failed to fetch customers: " + response.message)
            }
        } catch (error) {
        } finally {
            dispatch(changeloaderState(false))
        }
    }, [param.id, dispatch])

    useEffect(() => {
        if (param.id) {
            fetchSensorSosSettingsDetails()
        }
    }, [fetchSensorSosSettingsDetails, param])

    const validationSchema = Yup.object().shape({
        sensorId: Yup.string().trim().required("Please enter Sensor ID"),
    })

    const formik = useFormik({
        initialValues: {
            sensorId: "",
            sosIds: [""],
        },
        validationSchema,
        onSubmit: async (values, { resetForm }) => {
            const payload = {
                ...values,
                sosIds: values.sosIds.filter((id: string) => id.trim() !== ""),
            }
            if(payload?.sosIds?.length > 0){
                if (param.id) {
                    try {
                        setLoading(true)
                        const response = await request<SendNotifications>({
                            url: `/wqdbhiuwdhiuwhd/${param.id}`,
                            method: "POST",
                            data: payload,
                        })
                        if (response.success) {
                            toast.success(response.message)
                            navigate("/sensor-sos-settings")
                        } else {
                            toast.error(response.message)
                        }
                    } catch (error: any) {
                        toast.error(`${error.message}`)
                    } finally {
                        setLoading(false)
                    }
                }
                else {
                    try {
                        setLoading(true)
                        const response = await request<SendNotifications>({
                            url: `/wqdbhiuwdhiuwhd`,
                            method: "POST",
                            data: payload,
                        })
                        if (response.success) {
                            toast.success(response.message)
                            navigate("/sensor-sos-settings")
                        } else {
                            toast.error(response.message)
                        }
                    } catch (error: any) {
                        toast.error(`${error.message}`)
                    } finally {
                        setLoading(false)
                    }
                }
            }
            else{
                toast.error("wdwd")
            }
        },
    })

    return (
        <div className='col-xl-6 col-lg-8 col-md-8 col-12 mt-4 w-100'>
            <FormikProvider value={formik}>
                <form onSubmit={formik.handleSubmit} className='customer-edit-form'>
                    {/* Sensor ID */}
                    <div className="row">
                        <div className='form-group login-input-section mb-3 col-6'>
                            <label htmlFor='sensorId'>Sensor ID</label>
                            <Form.Control
                                type='text'
                                id='sensorId'
                                name='sensorId'
                                placeholder='Enter Sensor ID'
                                value={formik.values.sensorId}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={!!formik.errors.sensorId && formik.touched.sensorId}
                            />
                            <span className='text-red-500 text-xs'>
                                {formik.touched.sensorId && formik.errors.sensorId}
                            </span>
                        </div>

                        {/* SOS IDs (no validation) */}
                        <div className='form-group login-input-section mb-3 col-6'>
                            <label>SOS IDs</label>
                            <FieldArray
                                name="sosIds"
                                render={(arrayHelpers) => (
                                    <div className='d-flex flex-column gap-2'>
                                        {formik.values.sosIds.map((sosId, index) => (
                                            <div key={index} className='d-flex gap-2 mb-2'>
                                                <Form.Control
                                                    type='text'
                                                    name={`sosIds[${index}]`}
                                                    placeholder={`Enter SOS ID ${index + 1}`}
                                                    value={sosId}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                />
                                                <button
                                                    type="button"
                                                    className="btn btn-danger px-2"
                                                    onClick={() => arrayHelpers.remove(index)}
                                                    disabled={formik.values.sosIds.length === 1}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#fff" viewBox="0 0 256 256"><path d="M216,48H176V40a24,24,0,0,0-24-24H104A24,24,0,0,0,80,40v8H40a8,8,0,0,0,0,16h8V208a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V64h8a8,8,0,0,0,0-16ZM96,40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96Zm96,168H64V64H192ZM112,104v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm48,0v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Z"></path></svg>
                                                </button>
                                            </div>
                                        ))}
                                        <button
                                            type="button"
                                            className="btn btn-success"
                                            onClick={() => arrayHelpers.push("")}
                                        >
                                            + Add SOS ID
                                        </button>
                                    </div>
                                )}
                            />
                        </div>
                    </div>

                    {/* Buttons */}
                                    <div className='col-12'>
                  <div className='d-flex gap-3 justify-content-center'>
                    <div className='d-flex gap-3'>
                            <PrimaryButton
                                type='submit'
                                label={loading ? 'Submitting...' : "Save"}
                                className='editFormButton w-100'
                                disabled={loading}
                            />
                            <SecondaryButton
                                type='button'
                                onClick={() => formik.resetForm()}
                                label='Cancel'
                                className='editFormButton w-100'
                            />
                            </div>
                        </div>
                    </div>
                </form>
            </FormikProvider>
        </div>
    )
}

export default SensorSosSettingsComp
